var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.wrapperClass},[(_vm.field.component)?_c(_vm.field.component,_vm._g(_vm._b({tag:"component",class:_vm.classes,attrs:{"item":_vm.item,"value":_vm.value,"requestParams":_vm.requestParams}},'component',_vm.attrs,false),_vm.listeners),[_vm._v(_vm._s(_vm.value))]):[_vm._v(_vm._s(_vm.valueHandler))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }